/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
/* eslint-disable max-lines */
import merge from 'lodash/merge';
import {
  BasicFuncs,
  BasicConfig,
  // types:
  Operators,
  Fields,
  Types,
  Conjunctions,
  LocaleSettings,
  OperatorProximity,
  Funcs,
  Settings,
  Widgets,
  Config,
} from '@react-awesome-query-builder/ui';
import en_US from 'antd/es/date-picker/locale/en_US';
import { AntdConfig } from '@react-awesome-query-builder/antd';
import A8MultipleSelect from './custom_widget/A8MultipleSelect';
import sqlBuilderFunctions from './functions/sqlBuilderFunctions';
import ONLY_FIELDS from './functions/number/ONLY_FIELDS';
import GREATEST from './functions/number/GREATEST';
import LEAST from './functions/number/LEAST';
import LENGTH from './functions/string/LENGTH';

import STRING_ONLY_FIELDS from './functions/string/STRING_ONLY_FIELDS';
import FIND from './functions/string/FIND';
import MAX from './functions/number/MAX';
import MIN from './functions/number/MIN';
import DATE_BETWEEN from './functions/date/DATE_BETWEEN';
import DAYS_BETWEEN from './functions/date/DAYS_BETWEEN';
import DATE_ADDITION from './functions/date/DATE_ADDITION';
import DATE_SUBTRACTION from './functions/date/DATE_SUBTRACTION';
import UNIFIED_RANGE_BETWEEN from './functions/date/UNIFIED_RANGE_BETWEEN';
import UNIFIED_MONTHS_BETWEEN from './functions/date/UNIFIED_MONTHS_BETWEEN';
import UNIFIED_WEEKS_BETWEEN from './functions/date/UNIFIED_WEEKS_BETWEEN';
import UNIFIED_YEARS_BETWEEN from './functions/date/UNIFIED_YEARS_BETWEEN';
import UNIFIED_DAYS_BETWEEN from './functions/date/UNIFIED_DAYS_BETWEEN';

import { Input, Popover, Select } from 'antd';

const skinToConfig: Record<string, Config> = {
  vanilla: BasicConfig,
  antd: AntdConfig,
};

export default (skin: string, customFields: Fields) => {
  const InitialConfig = skinToConfig[skin] as BasicConfig;

  const conjunctions: Conjunctions = {
    ...InitialConfig.conjunctions,
  };

  const proximity: OperatorProximity = {
    ...InitialConfig.operators.proximity,
    valueLabels: [
      { label: 'Word 1', placeholder: 'Enter first word' },
      { label: 'Word 2', placeholder: 'Enter second word' },
    ],
    textSeparators: [
      // 'Word 1',
      // 'Word 2'
    ],
    options: {
      ...InitialConfig.operators.proximity.options,
      optionLabel: 'Near', // label on top of "near" selectbox (for config.settings.showLabels==true)
      optionTextBefore: 'Near', // label before "near" selectbox (for config.settings.showLabels==false)
      optionPlaceholder: 'Select words between', // placeholder for "near" selectbox
      minProximity: 2,
      maxProximity: 10,
      defaults: {
        proximity: 2,
      },
      customProps: {},
    },
  };
  const operators: Operators = {
    ...InitialConfig.operators,
    // examples of  overriding
    proximity,
    between: {
      ...InitialConfig.operators.between,
      valueLabels: ['Value from', 'Value to'],
      textSeparators: ['from', 'to'],
    },
    a8NoOperator: {
      label: 'No Operator',
      reversedOp: 'a8NoOperator',
      cardinality: 0,
      labelForFormat: 'A8_NO_OPERATOR',
      sqlOp: 'A8_NO_OPERATOR',
      formatOp: function formatOp(
        field,
        op,
        value,
        valueSrc,
        valueType,
        opDef,
        operatorOptions,
        isForDisplay
      ) {
        return ''.concat(field, 'A8_NO_OPERATOR');
      },
      jsonLogic: function (
        field,
        op,
        value,
        valueSrc,
        valueType,
        opDef,
        operatorOptions,
        isForDisplay
      ) {
        return {
          ...field,
        };
      },
      sqlFormatOp: function spelFormatOp(
        field,
        op,
        values,
        valueSrc,
        valueTypes,
        opDef,
        operatorOptions,
        fieldDef
      ) {
        return ''.concat(field, 'A8_NO_OPERATOR');
      },
    },
    In: {
      label: 'In',
      cardinality: 1,
      valueSources: ['value'],
      formatOp: function formatOp(
        field,
        op,
        values,
        valueSrc,
        valueTypes,
        opDef,
        operatorOptions,
        fieldDef
      ) {
        let valueArray = [];

        if (typeof values === 'string') {
          // Check what format we have
          const trimmed = values.trim();

          // Format 1: Single quoted string with commas inside: '1,23,3  ,33'
          if ((trimmed.startsWith("'") && trimmed.endsWith("'")) ||
            (trimmed.startsWith('"') && trimmed.endsWith('"'))) {
            // Remove the outer quotes
            const inner = trimmed.substring(1, trimmed.length - 1);
            // Split by comma and clean up
            valueArray = inner.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 2: Already comma-separated with quotes: '1', '2', '3'
          else if (trimmed.includes("',") || trimmed.includes('",')) {
            // Remove all quotes and split
            const withoutQuotes = trimmed.replace(/['"]/g, '');
            valueArray = withoutQuotes.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 3: Simple comma-separated without quotes: 1,2,3
          else {
            valueArray = trimmed.split(',').map(v => v.trim()).filter(v => v !== '');
          }
        } else if (Array.isArray(values)) {
          valueArray = values.map(v => String(v).trim()).filter(v => v !== '');
        } else {
          const val = String(values || '').trim();
          valueArray = val !== '' ? [val] : [];
        }

        if (valueArray.length === 0) {
          return `${field} In ()`;
        }

        if (valueTypes && valueTypes.includes('text')) {
          const quotedValues = valueArray.map(v => `'${v}'`).join(', ');
          return `${field} In (${quotedValues})`;
        }

        return `${field} In (${valueArray.join(', ')})`;
      },
      jsonLogic: function (
        field,
        op,
        value,
        valueSrc,
        valueType,
        opDef,
        operatorOptions,
        isForDisplay
      ) {
        let valueArray;

        // Handle both string and ImmutableList cases
        if (typeof value === 'string') {
          // If it's a string, split by comma and trim
          valueArray = value.split(',').map(item => item.trim()).filter(item => item !== '');
        } else if (value && typeof value === 'object' && value.toJS) {
          // If it's an ImmutableList, convert to regular array and trim
          valueArray = value.toJS().map(item =>
            typeof item === 'string' ? item.trim() : item
          ).filter(item => item !== '');
        } else if (Array.isArray(value)) {
          // If it's already an array (shouldn't happen based on cardinality: 1, but just in case)
          valueArray = value.map(item =>
            typeof item === 'string' ? item.trim() : item
          ).filter(item => item !== '');
        } else {
          // Fallback - convert to string and handle
          const valueStr = String(value || '');
          valueArray = valueStr.split(',').map(item => item.trim()).filter(item => item !== '');
        }

        return {
          "in": [
            field,
            valueArray
          ]
        };
      },
      sqlFormatOp: function sqlFormatOp(
        field,
        op,
        values,
        valueSrc,
        valueTypes,
        opDef,
        operatorOptions,
        fieldDef
      ) {
        let valueArray = [];

        if (typeof values === 'string') {
          // Check what format we have
          const trimmed = values.trim();

          // Format 1: Single quoted string with commas inside: '1,23,3  ,33'
          if ((trimmed.startsWith("'") && trimmed.endsWith("'")) ||
            (trimmed.startsWith('"') && trimmed.endsWith('"'))) {
            // Remove the outer quotes
            const inner = trimmed.substring(1, trimmed.length - 1);
            // Split by comma and clean up
            valueArray = inner.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 2: Already comma-separated with quotes: '1', '2', '3'
          else if (trimmed.includes("',") || trimmed.includes('",')) {
            // Remove all quotes and split
            const withoutQuotes = trimmed.replace(/['"]/g, '');
            valueArray = withoutQuotes.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 3: Simple comma-separated without quotes: 1,2,3
          else {
            valueArray = trimmed.split(',').map(v => v.trim()).filter(v => v !== '');
          }
        } else if (Array.isArray(values)) {
          valueArray = values.map(v => String(v).trim()).filter(v => v !== '');
        } else {
          const val = String(values || '').trim();
          valueArray = val !== '' ? [val] : [];
        }

        if (valueArray.length === 0) {
          return `${field} In ()`;
        }

        if (valueTypes && valueTypes.includes('text')) {
          const quotedValues = valueArray.map(v => `'${v}'`).join(', ');
          return `${field} In (${quotedValues})`;
        }

        return `${field} In (${valueArray.join(', ')})`;
      },
    },
    'Not In': {
      label: ' Not In',
      cardinality: 1,
      valueSources: ['value'],
      formatOp: function formatOp(
        field,
        op,
        values,
        valueSrc,
        valueTypes,
        opDef,
        operatorOptions,
        fieldDef
      ) {
        let valueArray = [];

        if (typeof values === 'string') {
          // Check what format we have
          const trimmed = values.trim();

          // Format 1: Single quoted string with commas inside: '1,23,3  ,33'
          if ((trimmed.startsWith("'") && trimmed.endsWith("'")) ||
            (trimmed.startsWith('"') && trimmed.endsWith('"'))) {
            // Remove the outer quotes
            const inner = trimmed.substring(1, trimmed.length - 1);
            // Split by comma and clean up
            valueArray = inner.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 2: Already comma-separated with quotes: '1', '2', '3'
          else if (trimmed.includes("',") || trimmed.includes('",')) {
            // Remove all quotes and split
            const withoutQuotes = trimmed.replace(/['"]/g, '');
            valueArray = withoutQuotes.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 3: Simple comma-separated without quotes: 1,2,3
          else {
            valueArray = trimmed.split(',').map(v => v.trim()).filter(v => v !== '');
          }
        } else if (Array.isArray(values)) {
          valueArray = values.map(v => String(v).trim()).filter(v => v !== '');
        } else {
          const val = String(values || '').trim();
          valueArray = val !== '' ? [val] : [];
        }

        if (valueArray.length === 0) {
          return `${field} NOT IN ()`;
        }

        if (valueTypes && valueTypes.includes('text')) {
          const quotedValues = valueArray.map(v => `'${v}'`).join(', ');
          return `${field} NOT IN (${quotedValues})`;
        }

        return `${field} NOT IN (${valueArray.join(', ')})`;
      },
      jsonLogic: function (
        field,
        op,
        value,
        valueSrc,
        valueType,
        opDef,
        operatorOptions,
        isForDisplay
      ) {
        let valueArray;

        // Handle both string and ImmutableList cases
        if (typeof value === 'string') {
          // If it's a string, split by comma and trim
          valueArray = value.split(',').map(item => item.trim()).filter(item => item !== '');
        } else if (value && typeof value === 'object' && value.toJS) {
          // If it's an ImmutableList, convert to regular array and trim
          valueArray = value.toJS().map(item =>
            typeof item === 'string' ? item.trim() : item
          ).filter(item => item !== '');
        } else if (Array.isArray(value)) {
          // If it's already an array (shouldn't happen based on cardinality: 1, but just in case)
          valueArray = value.map(item =>
            typeof item === 'string' ? item.trim() : item
          ).filter(item => item !== '');
        } else {
          // Fallback - convert to string and handle
          const valueStr = String(value || '');
          valueArray = valueStr.split(',').map(item => item.trim()).filter(item => item !== '');
        }
        return {
          "!": {
            "in": [
              field,
              valueArray
            ]
          }
        };
      },
      sqlFormatOp: function sqlFormatOp(
        field,
        op,
        values,
        valueSrc,
        valueTypes,
        opDef,
        operatorOptions,
        fieldDef
      ) {
        let valueArray = [];

        if (typeof values === 'string') {
          // Check what format we have
          const trimmed = values.trim();

          // Format 1: Single quoted string with commas inside: '1,23,3  ,33'
          if ((trimmed.startsWith("'") && trimmed.endsWith("'")) ||
            (trimmed.startsWith('"') && trimmed.endsWith('"'))) {
            // Remove the outer quotes
            const inner = trimmed.substring(1, trimmed.length - 1);
            // Split by comma and clean up
            valueArray = inner.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 2: Already comma-separated with quotes: '1', '2', '3'
          else if (trimmed.includes("',") || trimmed.includes('",')) {
            // Remove all quotes and split
            const withoutQuotes = trimmed.replace(/['"]/g, '');
            valueArray = withoutQuotes.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 3: Simple comma-separated without quotes: 1,2,3
          else {
            valueArray = trimmed.split(',').map(v => v.trim()).filter(v => v !== '');
          }
        } else if (Array.isArray(values)) {
          valueArray = values.map(v => String(v).trim()).filter(v => v !== '');
        } else {
          const val = String(values || '').trim();
          valueArray = val !== '' ? [val] : [];
        }

        if (valueArray.length === 0) {
          return `${field} NOT IN ()`;
        }

        if (valueTypes && valueTypes.includes('text')) {
          const quotedValues = valueArray.map(v => `'${v}'`).join(', ');
          return `${field} NOT IN (${quotedValues})`;
        }
        return `${field} NOT IN (${valueArray.join(', ')})`;
      },
    },
    Like: {
      label: 'Like',
      cardinality: 1,
      valueSources: ['value'],

      formatOp: function formatOp(
        field,
        op,
        value,
        valueSrc,
        valueType,
        opDef,
        operatorOptions,
        isForDisplay
      ) {
        let valueArray = [];

        // Parse the value string similar to the In operator
        if (typeof value === 'string') {
          const trimmed = value.trim();

          // Format 1: Single quoted string with commas inside: 'apple,banana,cherry'
          if ((trimmed.startsWith("'") && trimmed.endsWith("'")) ||
            (trimmed.startsWith('"') && trimmed.endsWith('"'))) {
            const inner = trimmed.substring(1, trimmed.length - 1);
            valueArray = inner.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 2: Already comma-separated with quotes: 'apple', 'banana', 'cherry'
          else if (trimmed.includes("',") || trimmed.includes('",')) {
            const withoutQuotes = trimmed.replace(/['"]/g, '');
            valueArray = withoutQuotes.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 3: Simple comma-separated without quotes: apple,banana,cherry
          else {
            valueArray = trimmed.split(',').map(v => v.trim()).filter(v => v !== '');
          }
        } else if (Array.isArray(value)) {
          valueArray = value.map(v => String(v).trim()).filter(v => v !== '');
        } else if (value && typeof value === 'object' && value.toJS) {
          // Handle ImmutableList
          valueArray = value.toJS().map(item =>
            typeof item === 'string' ? item.trim() : String(item)
          ).filter(item => item !== '');
        } else {
          const val = String(value || '').trim();
          valueArray = val !== '' ? [val] : [];
        }

        if (valueArray.length === 0) {
          return `${field} Like ()`;
        }

        // Format for display: field Like (value1, value2, ...)
        if (valueType === 'text') {
          const quotedValues = valueArray.map(v => `'${v}'`).join(', ');
          return `${field} Like (${quotedValues})`;
        }

        return `${field} Like (${valueArray.join(', ')})`;
      },

      jsonLogic: function (
        field,
        op,
        value,
        valueSrc,
        valueType,
        opDef,
        operatorOptions,
        isForDisplay
      ) {
        let valueArray = [];

        // Parse the value similar to formatOp
        if (typeof value === 'string') {
          const trimmed = value.trim();

          if ((trimmed.startsWith("'") && trimmed.endsWith("'")) ||
            (trimmed.startsWith('"') && trimmed.endsWith('"'))) {
            const inner = trimmed.substring(1, trimmed.length - 1);
            valueArray = inner.split(',').map(v => v.trim()).filter(v => v !== '');
          } else if (trimmed.includes("',") || trimmed.includes('",')) {
            const withoutQuotes = trimmed.replace(/['"]/g, '');
            valueArray = withoutQuotes.split(',').map(v => v.trim()).filter(v => v !== '');
          } else {
            valueArray = trimmed.split(',').map(v => v.trim()).filter(v => v !== '');
          }
        } else if (Array.isArray(value)) {
          valueArray = value.map(v => String(v).trim()).filter(v => v !== '');
        } else if (value && typeof value === 'object' && value.toJS) {
          valueArray = value.toJS().map(item =>
            typeof item === 'string' ? item.trim() : String(item)
          ).filter(item => item !== '');
        } else {
          const val = String(value || '').trim();
          valueArray = val !== '' ? [val] : [];
        }

        // Add % wildcards for LIKE operation
        const likePatterns = valueArray.map(val => `%${val}%`);

        // For jsonLogic, we need to handle multiple LIKE conditions with OR
        if (valueArray.length === 0) {
          return false; // No values to match
        }

        // If only one value, simple LIKE
        if (valueArray.length === 1) {
          return {
            "LIKE": [
              field,
              likePatterns[0]
            ]
          };
        }

        // If multiple values, create OR conditions
        return {
          "or": likePatterns.map(pattern => ({
            "LIKE": [field, pattern]
          }))
        };
      },

      sqlFormatOp: function sqlFormatOp(
        field,
        op,
        values,
        valueSrc,
        valueTypes,
        opDef,
        operatorOptions,
        fieldDef
      ) {
        let valueArray = [];

        if (typeof values === 'string') {
          const trimmed = values.trim();

          // Format 1: Single quoted string with commas
          if ((trimmed.startsWith("'") && trimmed.endsWith("'")) ||
            (trimmed.startsWith('"') && trimmed.endsWith('"'))) {
            const inner = trimmed.substring(1, trimmed.length - 1);
            valueArray = inner.split(',').map(v => v.trim()).filter(v => v !== '');
          }
          // Format 2: Comma-separated with quotes
          else if (trimmed.includes("',") || trimmed.includes('",')) {
            const withoutQuotes: any = trimmed.replace(/['"]/g, '');
            valueArray = withoutQuotes.split(',').map(v => v.trim()).filter((v: any) => v !== '');
          }
          // Format 3: Simple comma-separated
          else {
            valueArray = trimmed.split(',').map(v => v.trim()).filter(v => v !== '');
          }
        } else if (Array.isArray(values)) {
          valueArray = values.map(v => String(v).trim()).filter(v => v !== '');
        } else {
          const val = String(values || '').trim();
          valueArray = val !== '' ? [val] : [];
        }

        if (valueArray.length === 0) {
          return `FALSE`; // Or empty condition
        }

        // Add wildcards for LIKE
        const likePatterns = valueArray.map(val => `${val}`);

        // Build SQL with escaped values
        const isText = valueTypes && valueTypes.includes('text');
        const conditions = likePatterns.map(pattern => {
          const escapedPattern = isText ? `'${pattern.replace(/'/g, "''")}'` : pattern;
          return `${field} LIKE ${escapedPattern}`;
        });

        if (conditions.length === 1) {
          return conditions[0];
        }

        // Multiple values = OR conditions
        return `(${conditions.join(' OR ')})`;
      },
    },
    starts_with: { ...InitialConfig.operators.starts_with, label: 'Starts with', cardinality: 1, valueSources: ['value'], formatOp: function formatOp(field, op, value, valueSrc, valueType, opDef, operatorOptions, isForDisplay) { const val = String(value ?? '').trim(); if (!val) { return `${field} LIKE ''`; } const escapedValue = val.replace(/'/g, "''"); return `${field} LIKE '${escapedValue}%'`; }, sqlFormatOp: function sqlFormatOp(field, op, value, valueSrc, valueTypes, opDef, operatorOptions, fieldDef) { const val = String(value ?? '').trim(); if (!val) { return 'FALSE'; } const escapedValue = val.replace(/'/g, "''"); return `${field} LIKE '${escapedValue}%'`; }, jsonLogic: function (field, op, value, valueSrc, valueType, opDef, operatorOptions, isForDisplay) { const val = String(value ?? '').trim(); if (!val) { return false; } return { LIKE: [field, `${val}%`,], }; }, }, ends_with: { ...InitialConfig.operators.ends_with, label: 'Ends with', cardinality: 1, valueSources: ['value'], formatOp: function formatOp(field, op, value, valueSrc, valueType, opDef, operatorOptions, isForDisplay) { const val = String(value ?? '').trim(); if (!val) { return `${field} LIKE ''`; } const escapedValue = val.replace(/'/g, "''"); return `${field} LIKE '%${escapedValue}'`; }, sqlFormatOp: function sqlFormatOp(field, op, value, valueSrc, valueTypes, opDef, operatorOptions, fieldDef) { const val = String(value ?? '').trim(); if (!val) { return 'FALSE'; } const escapedValue = val.replace(/'/g, "''"); return `${field} LIKE '%${escapedValue}'`; }, jsonLogic: function (field, op, value, valueSrc, valueType, opDef, operatorOptions, isForDisplay) { const val = String(value ?? '').trim(); if (!val) { return false; } return { LIKE: [field, `%${val}`,], }; }, },
  };

  const widgets: Widgets = {
    ...InitialConfig.widgets,
    // examples of overriding
    text: {
      ...InitialConfig.widgets.text,
    },
    textarea: {
      ...InitialConfig.widgets.textarea,
      maxRows: 3,
    },
    rangeslider: {
      ...InitialConfig.widgets.rangeslider,
    },
    date: {
      ...InitialConfig.widgets.date,
      dateFormat: 'DD/MM/YYYY',
      valueFormat: 'YYYY-MM-DD',
    },
    time: {
      ...InitialConfig.widgets.time,
      timeFormat: 'HH:mm',
      valueFormat: 'HH:mm:ss',
    },
    datetime: {
      ...InitialConfig.widgets.datetime,
      timeFormat: 'HH:mm',
      dateFormat: 'DD/MM/YYYY',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
    },
    func: {
      ...InitialConfig.widgets.func,
      customProps: {
        showSearch: true,
        filterOption: (input, option) =>
          option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0,
        optionFilterProp: 'children',
      },
    },
    select: {
      ...InitialConfig.widgets.select,
      customProps: {
        showSearch: true,
      },
    },
    multiselect: {
      ...InitialConfig.widgets.multiselect,
      valueSrc: 'value',
      customProps: {
        // showCheckboxes: false,
        width: '200px',
        input: {
          width: '100px',
        },
      },
    },
    a8fields: {
      ...InitialConfig.widgets.text,
      type: 'a8fields',
      factory: (props) => <A8MultipleSelect {...props} />,
      formatValue: (val, _fieldDef, _wgtDef, isForDisplay) => {

        return isForDisplay ? val.toString() : JSON.stringify(val);
      },
    },
    a8multiselect: {
      ...InitialConfig.widgets.text,
      type: 'a8multiselect',
      factory: (props) => <A8MultipleSelect {...props} mode="tags" />,
      formatValue: (val, _fieldDef, _wgtDef, isForDisplay) => {

        return isForDisplay ? val.toString() : JSON.stringify(val);
      },
    },
    treeselect: {
      ...InitialConfig.widgets.treeselect,
      customProps: {
        showSearch: true,
      },
    },
  };

  const types: Types = {
    ...InitialConfig.types,

    // examples of  overriding
    number: {
      ...InitialConfig.types.number,
      widgets: {
        number: {
          operators: [
            'a8NoOperator',
            'equal',
            'not_equal',
            'less',
            'less_or_equal',
            'greater',
            'greater_or_equal',
            'between',
            'not_between',
            'is_null',
            'is_not_null',
          ],
          defaultOperator: 'a8NoOperator',
        },
      },
    },
    text: {
      ...InitialConfig.types.text,
      widgets: {
        text: {
          operators: [
            'a8NoOperator',
            'proximity',
            'equal',
            'not_equal',
            'less',
            'less_or_equal',
            'greater',
            'greater_or_equal',
            'like',
            'not_like',
            'starts_with',
            'ends_with',
            'between',
            'not_between',
            'is_null',
            'is_not_null',
            'is_empty',
            'is_not_empty',
            'In',
            'Not In',
            'Like',

          ],
          defaultOperator: 'a8NoOperator',
        },
      },
    },
    date: {
      ...InitialConfig.types.date,
      widgets: {
        date: {
          operators: [
            'a8NoOperator',
            'equal',
            'not_equal',
            'less',
            'less_or_equal',
            'greater',
            'greater_or_equal',
            'between',
            'not_between',
            'is_null',
            'is_not_null',
          ],
          defaultOperator: 'a8NoOperator',
        },
      },
    },
    a8fields: {
      valueSources: ['value'],
      widgets: {
        a8fields: {
          operators: ['a8NoOperator'],
          defaultOperator: 'a8NoOperator',
        },
      },
    },
    a8multiselect: {
      ...InitialConfig.types.text,
      widgets: {
        a8multiselect: {
          operators: ['a8NoOperator'],
          defaultOperator: 'a8NoOperator',
        },
      },
    },
    a8text: {
      ...InitialConfig.types.text,
      widgets: {
        text: {
          operators: ['a8NoOperator'],
          defaultOperator: 'a8NoOperator',
        },
      },
    },
    boolean: merge({}, InitialConfig.types.boolean, {
      widgets: {
        boolean: {
          widgetProps: {
            hideOperator: true,
            operatorInlineLabel: 'is',
          },
          opProps: {
            equal: {
              label: 'is',
            },
            not_equal: {
              label: 'is not',
            },
          },
        },
      },
    }),
  };


  interface ExtendedSettings extends Settings {
    renderValueSources?: any;
  }

  const localeSettings: LocaleSettings = {
    locale: {
      moment: 'en',
      antd: en_US,

    },
    valueLabel: 'Value',
    valuePlaceholder: 'Value',
    fieldLabel: 'Field',
    operatorLabel: 'Operator',
    funcLabel: 'Function',
    fieldPlaceholder: 'Select field',
    funcPlaceholder: 'Select function',
    operatorPlaceholder: 'Select operator',
    lockLabel: 'Lock',
    lockedLabel: 'Locked',
    deleteLabel: undefined,
    addRuleLabel: '++ Add Nested Conditions',
    addGroupLabel: '+ Add Rule',
    addSubRuleLabel: 'Add sub rule',
    delGroupLabel: undefined,
    notLabel: 'Not',
    fieldSourcesPopupTitle: 'Select source',
    valueSourcesPopupTitle: 'Select value source',
    removeRuleConfirmOptions: {
      title: 'Are you sure delete this rule?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'Cancel',
    },
    removeGroupConfirmOptions: {
      title: 'Are you sure delete this group?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'Cancel',
    },
  };


  const settings: ExtendedSettings = {
    ...InitialConfig.settings,
    ...localeSettings,
    defaultSliderWidth: '200px',
    defaultSelectWidth: '200px',
    defaultSearchWidth: '100px',
    defaultMaxRows: 5,
    renderSize: 'large',

    showNot: true,
    showLabels: false,
    defaultOperator: 'a8NoOperator',

    valueSourcesInfo: {
      value: {
        label: 'Value',
      },
      field: {
        label: 'Field',

      },
      func: {
        label: 'Function',

      },
    },
    fieldSources: ['field', 'func'],
    keepInputOnChangeFieldSrc: true,
    maxNesting: 5,
    canLeaveEmptyGroup: true,
    shouldCreateEmptyGroup: false,
    showErrorMessage: true,
    removeEmptyGroupsOnLoad: false,
    removeIncompleteRulesOnLoad: false,
    customFieldSelectProps: {
      showSearch: true,
    },
    renderFunc: (props: any) => {
      const { items, selectedKey, setField, readonly, placeholder } = props;

      // Build grouped options (preserves grouping)
      const buildGroupedOptions = (items: any) => {
        const options: any[] = [];

        Object.entries(items || {}).forEach(([key, item]: [string, any]) => {
          if (item.items && Array.isArray(item.items)) {
            const groupOption = {
              label: item.label || key,
              options: item.items.map((subItem: any) => ({
                value: subItem.path || subItem.key,
                label: subItem.label || subItem.key,
                searchText: `${item.label} ${subItem.label}`.toLowerCase(),
              }))
            };
            options.push(groupOption);
          } else {
            options.push({
              value: item.path || key,
              label: item.fullLabel || item.label || key,
              searchText: (item.fullLabel || item.label || key).toLowerCase(),
            });
          }
        });

        return options;
      };

      // Use grouped options for better UX
      const options = buildGroupedOptions(items);

      return (
        <Select
          value={selectedKey}
          onChange={setField}
          className='custom-class'
          dropdownClassName='custom-dropdown-class'

          disabled={readonly}
          placeholder={placeholder || "Select function"}
          showSearch

          style={{ minWidth: 140 }}
          filterOption={(input: string, option: any) => {
            const searchText = input.toLowerCase();

            // Search in option label
            if (option.label && option.label.toString().toLowerCase().includes(searchText)) {
              return true;
            }

            // Search in custom searchText if available
            if (option.searchText && option.searchText.includes(searchText)) {
              return true;
            }

            return false;
          }}
          options={options}
        />
      );
    },



    renderValueSources: (props: any) => {
      const { valueSources, valueSrc, setValueSrc, readonly, title } = props;

      const isViewMode = window.location.href.toLowerCase().includes('show');
      const isDisabled = readonly || isViewMode;

      const getSourceIcon = (sourceType: string) => {
        switch (sourceType) {
          case 'func':
            return (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.38547 3.17429C7.77124 2.83736 8.21717 2.70752 8.69742 2.70752C9.34701 2.70752 9.80943 3.02786 10.1075 3.44304C10.3848 3.8292 10.5254 4.29964 10.6096 4.67859L9.38926 4.9494C9.31609 4.61991 9.21959 4.3496 9.09217 4.17214C8.98559 4.02369 8.87559 3.95752 8.69742 3.95752C8.46151 3.95752 8.32556 4.01287 8.20776 4.11575C8.06592 4.23964 7.89875 4.4791 7.71199 4.95129C7.48025 5.53719 7.26023 6.36554 6.99963 7.52234H8.69742V8.77235H6.7277C6.63914 9.19019 6.5453 9.6406 6.44473 10.126C5.91298 12.6926 5.54359 14.4254 5.11585 15.5069C4.89976 16.0532 4.6417 16.5082 4.27998 16.8241C3.89422 17.161 3.44828 17.2909 2.96802 17.2909C2.31842 17.2909 1.85607 16.9705 1.55793 16.5554C1.28062 16.1692 1.14001 15.6988 1.05591 15.3198L2.27622 15.0489C2.34934 15.3784 2.44583 15.6488 2.57327 15.8262C2.67987 15.9747 2.78989 16.0409 2.96802 16.0409C3.20394 16.0409 3.3399 15.9855 3.4577 15.8826C3.59954 15.7588 3.76671 15.5193 3.95347 15.0471C4.33143 14.0915 4.67821 12.491 5.22072 9.87235C5.30055 9.4871 5.37671 9.1206 5.44996 8.77235H4.09662V7.52234H5.7186C6.01222 6.19574 6.2683 5.20277 6.54961 4.49154C6.7657 3.94519 7.02377 3.49021 7.38547 3.17429Z" fill="currentColor" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7072 13.4003C17.7159 12.5084 17.4828 11.5614 16.9238 10.2442L18.0745 9.75586C18.6658 11.1494 18.9682 12.2778 18.9572 13.4125C18.9461 14.5461 18.6225 15.6237 18.0742 16.9115L16.9241 16.4219C17.4469 15.1937 17.6985 14.2934 17.7072 13.4003Z" fill="currentColor" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.79147 13.4003C9.7828 12.5084 10.016 11.5614 10.575 10.2442L9.4243 9.75586C8.83289 11.1494 8.53047 12.2778 8.54155 13.4125C8.55264 14.5461 8.8763 15.6237 9.42455 16.9115L10.5746 16.4219C10.0518 15.1937 9.80022 14.2934 9.79147 13.4003Z" fill="currentColor" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5085 12.3176C12.4613 12.2999 12.388 12.2902 11.9113 12.2902V11.0402C11.9381 11.0402 11.9647 11.0401 11.9912 11.0401C12.3344 11.0395 12.658 11.0389 12.9466 11.1469C13.1104 11.2081 13.2649 11.2959 13.4009 11.4091C13.6422 11.6101 13.7751 11.8882 13.8916 12.1435C14.0198 11.996 14.1532 11.8545 14.2918 11.7266C14.6842 11.3646 15.1938 11.0402 15.8329 11.0402V12.2902C15.643 12.2902 15.4244 12.3825 15.1393 12.6455C14.9193 12.8483 14.7055 13.1092 14.4738 13.4111L14.6984 13.9C14.7791 14.0754 14.8236 14.171 14.8626 14.2394C14.883 14.2752 14.8944 14.2898 14.8985 14.2945C14.9205 14.3127 14.9511 14.3314 14.9906 14.3462C15.0378 14.3639 15.1111 14.3736 15.5878 14.3736V15.6236C15.5611 15.6236 15.5344 15.6236 15.5079 15.6236C15.1647 15.6243 14.8411 15.6249 14.5525 15.5169C14.3888 15.4556 14.2342 15.3679 14.0983 15.2546C13.8569 15.0536 13.7241 14.7756 13.6076 14.5203C13.4793 14.6678 13.3459 14.8093 13.2073 14.9371C12.8149 15.2991 12.3054 15.6236 11.6663 15.6236V14.3736C11.8562 14.3736 12.0747 14.2813 12.3599 14.0183C12.5798 13.8155 12.7937 13.5546 13.0253 13.2527L12.8007 12.7638C12.72 12.5884 12.6755 12.4928 12.6366 12.4244C12.6162 12.3886 12.6047 12.374 12.6006 12.3693C12.5787 12.3511 12.5481 12.3324 12.5085 12.3176Z" fill="currentColor" />
              </svg>
            );
          case 'field':
            return (
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 2.625C7 2.14175 7.39175 1.75 7.875 1.75H13.125C13.6083 1.75 14 2.14175 14 2.625C14 3.10825 13.6083 3.50001 13.125 3.50001H11.375V17.5H13.125C13.6083 17.5 14 17.8917 14 18.375C14 18.8582 13.6083 19.25 13.125 19.25H7.875C7.39175 19.25 7 18.8582 7 18.375C7 17.8917 7.39175 17.5 7.875 17.5H9.625V3.50001H7.875C7.39175 3.50001 7 3.10825 7 2.625ZM6.81451 5.25H7C7.48325 5.25 7.875 5.64175 7.875 6.12501C7.875 6.60826 7.48325 6.99999 7 6.99999H6.85125C6.0891 6.99999 5.57101 7.0007 5.17077 7.03395C4.78101 7.06631 4.58206 7.12494 4.44329 7.19703C4.12367 7.36306 3.86306 7.62367 3.69703 7.94329C3.62494 8.08206 3.56631 8.28101 3.53395 8.67077C3.50071 9.07101 3.50001 9.5891 3.50001 10.3513V10.6487C3.50001 11.4109 3.50071 11.929 3.53395 12.3292C3.56631 12.719 3.62494 12.9179 3.69703 13.0567C3.86306 13.3763 4.12367 13.6369 4.44329 13.803C4.58206 13.8751 4.78101 13.9337 5.17077 13.9661C5.57101 13.9993 6.0891 14 6.85125 14H7C7.48325 14 7.875 14.3918 7.875 14.875C7.875 15.3582 7.48325 15.75 7 15.75H6.81448C6.09828 15.75 5.50719 15.75 5.02594 15.7101C4.52601 15.6685 4.06678 15.5794 3.6366 15.356C2.99734 15.0239 2.47612 14.5027 2.14406 13.8634C1.92059 13.4332 1.83146 12.974 1.78995 12.4741C1.74998 11.9928 1.74999 11.4017 1.75 10.6855V10.3145C1.74999 9.59828 1.74998 9.00719 1.78995 8.52594C1.83146 8.02601 1.92059 7.56678 2.14406 7.1366C2.47612 6.49733 2.99734 5.97612 3.6366 5.64406C4.06678 5.4206 4.52601 5.33146 5.02594 5.28994C5.50719 5.24998 6.0983 5.25 6.81451 5.25ZM15.8292 7.03395C15.429 7.0007 14.9109 6.99999 14.1488 6.99999H14C13.5168 6.99999 13.125 6.60826 13.125 6.12501C13.125 5.64175 13.5168 5.25 14 5.25H14.1855C14.9017 5.25 15.4928 5.24998 15.9741 5.28994C16.474 5.33146 16.9332 5.4206 17.3634 5.64406C18.0027 5.97612 18.5239 6.49733 18.8559 7.1366C19.0794 7.56678 19.1685 8.02601 19.2101 8.52594C19.25 9.00719 19.25 9.5983 19.25 10.3145V10.6855C19.25 11.4017 19.25 11.9928 19.2101 12.4741C19.1685 12.974 19.0794 13.4332 18.8559 13.8634C18.5239 14.5027 18.0027 15.0239 17.3634 15.356C16.9332 15.5794 16.474 15.6685 15.9741 15.7101C15.4928 15.75 14.9017 15.75 14.1855 15.75H14C13.5168 15.75 13.125 15.3582 13.125 14.875C13.125 14.3918 13.5168 14 14 14H14.1488C14.9109 14 15.429 13.9993 15.8292 13.9661C16.219 13.9337 16.418 13.8751 16.5567 13.803C16.8763 13.6369 17.137 13.3763 16.5567 7.19703C16.418 7.12494 16.219 7.06631 15.8292 7.03395Z" fill="currentColor" />
              </svg>
            );
          case 'value':
            return (
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_1771_9403" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                  <path d="M0 1.90735e-06H18V18H0V1.90735e-06Z" fill="white" />
                </mask>
                <g mask="url(#mask0_1771_9403)">
                  <path d="M15.3281 17.4727H2.67188L9 9L2.67188 0.527346H15.3281" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.3281 0.527344V2.63672" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.3281 17.4727V15.3633" stroke="currentColor" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
            );
          default:
            return (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.38547 3.17429C7.77124 2.83736 8.21717 2.70752 8.69742 2.70752C9.34701 2.70752 9.80943 3.02786 10.1075 3.44304C10.3848 3.8292 10.5254 4.29964 10.6096 4.67859L9.38926 4.9494C9.31609 4.61991 9.21959 4.3496 9.09217 4.17214C8.98559 4.02369 8.87559 3.95752 8.69742 3.95752C8.46151 3.95752 8.32556 4.01287 8.20776 4.11575C8.06592 4.23964 7.89875 4.4791 7.71199 4.95129C7.48025 5.53719 7.26023 6.36554 6.99963 7.52234H8.69742V8.77235H6.7277C6.63914 9.19019 6.5453 9.6406 6.44473 10.126C5.91298 12.6926 5.54359 14.4254 5.11585 15.5069C4.89976 16.0532 4.6417 16.5082 4.27998 16.8241C3.89422 17.161 3.44828 17.2909 2.96802 17.2909C2.31842 17.2909 1.85607 16.9705 1.55793 16.5554C1.28062 16.1692 1.14001 15.6988 1.05591 15.3198L2.27622 15.0489C2.34934 15.3784 2.44583 15.6488 2.57327 15.8262C2.67987 15.9747 2.78989 16.0409 2.96802 16.0409C3.20394 16.0409 3.3399 15.9855 3.4577 15.8826C3.59954 15.7588 3.76671 15.5193 3.95347 15.0471C4.33143 14.0915 4.67821 12.491 5.22072 9.87235C5.30055 9.4871 5.37671 9.1206 5.44996 8.77235H4.09662V7.52234H5.7186C6.01222 6.19574 6.2683 5.20277 6.54961 4.49154C6.7657 3.94519 7.02377 3.49021 7.38547 3.17429Z" fill="currentColor" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7072 13.4003C17.7159 12.5084 17.4828 11.5614 16.9238 10.2442L18.0745 9.75586C18.6658 11.1494 18.9682 12.2778 18.9572 13.4125C18.9461 14.5461 18.6225 15.6237 18.0742 16.9115L16.9241 16.4219C17.4469 15.1937 17.6985 14.2934 17.7072 13.4003Z" fill="currentColor" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.79147 13.4003C9.7828 12.5084 10.016 11.5614 10.575 10.2442L9.4243 9.75586C8.83289 11.1494 8.53047 12.2778 8.54155 13.4125C8.55264 14.5461 8.8763 15.6237 9.42455 16.9115L10.5746 16.4219C10.0518 15.1937 9.80022 14.2934 9.79147 13.4003Z" fill="currentColor" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5085 12.3176C12.4613 12.2999 12.388 12.2902 11.9113 12.2902V11.0402C11.9381 11.0402 11.9647 11.0401 11.9912 11.0401C12.3344 11.0395 12.658 11.0389 12.9466 11.1469C13.1104 11.2081 13.2649 11.2959 13.4009 11.4091C13.6422 11.6101 13.7751 11.8882 13.8916 12.1435C14.0198 11.996 14.1532 11.8545 14.2918 11.7266C14.6842 11.3646 15.1938 11.0402 15.8329 11.0402V12.2902C15.643 12.2902 15.4244 12.3825 15.1393 12.6455C14.9193 12.8483 14.7055 13.1092 14.4738 13.4111L14.6984 13.9C14.7791 14.0754 14.8236 14.171 14.8626 14.2394C14.883 14.2752 14.8944 14.2898 14.8985 14.2945C14.9205 14.3127 14.9511 14.3314 14.9906 14.3462C15.0378 14.3639 15.1111 14.3736 15.5878 14.3736V15.6236C15.5611 15.6236 15.5344 15.6236 15.5079 15.6236C15.1647 15.6243 14.8411 15.6249 14.5525 15.5169C14.3888 15.4556 14.2342 15.3679 14.0983 15.2546C13.8569 15.0536 13.7241 14.7756 13.6076 14.5203C13.4793 14.6678 13.3459 14.8093 13.2073 14.9371C12.8149 15.2991 12.3054 15.6236 11.6663 15.6236V14.3736C11.8562 14.3736 12.0747 14.2813 12.3599 14.0183C12.5798 13.8155 12.7937 13.5546 13.0253 13.2527L12.8007 12.7638C12.72 12.5884 12.6755 12.4928 12.6366 12.4244C12.6162 12.3886 12.6047 12.374 12.6006 12.3693C12.5787 12.3511 12.5481 12.3324 12.5085 12.3176Z" fill="currentColor" />
              </svg>
            );
        }
      };

      const currentSource = valueSrc || 'value';
      const currentIcon = getSourceIcon(currentSource);

      return (
        <Popover
          content={
            !isDisabled ? (
              <div
                style={{
                  display: 'flex',
                  border: '1px solid #E8F1FF',
                  borderRadius: '6px',
                  overflow: 'hidden',
                  backgroundColor: '#fff',
                }}
              >
                {valueSources.map(([src, info]: [string, any], index: number) => {
                  const isActive = src === currentSource;
                  const icon = getSourceIcon(src);

                  return (
                    <div
                      key={src}
                      onClick={() => setValueSrc(src)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100px',
                        height: '32px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'Courier New, monospace',
                        backgroundColor: isActive ? '#120A8F' : '#fff',
                        color: isActive ? '#fff' : '#120A8F',
                        borderRight:
                          index < valueSources.length - 1
                            ? '1px solid #E8F1FF'
                            : 'none',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = isActive
                          ? '#120A8F'
                          : '#E8F1FF';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = isActive
                          ? '#120A8F'
                          : '#fff';
                      }}
                    >
                      <span style={{ marginRight: '4px', display: 'flex' }}>
                        {icon}
                      </span>
                      {src}
                    </div>
                  );
                })}
              </div>
            ) : null
          }
          trigger={isDisabled ? [] : 'hover'}   // ✅ no popover in view mode
          placement="top"
          overlayStyle={{ padding: 0 }}
        >
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '42px',
              height: '38px',
              borderRadius: '8px',
              border: '1px solid #d9d9d9',
              backgroundColor: isDisabled ? '#f5f5f5' : '#fff',
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              fontFamily: 'Courier New, monospace',
              color: '#999',
              transition: 'all 0.2s',
              pointerEvents: isDisabled ? 'none' : 'auto', // ✅ hard block
            }}
            onMouseEnter={(e) =>
              isDisabled
                ? null
                : (e.currentTarget.style.boxShadow =
                  '0 0 0 2px rgba(24, 144, 255, 0.2)')
            }
            onMouseLeave={(e) =>
              isDisabled
                ? null
                : (e.currentTarget.style.boxShadow = 'none')
            }
          >
            {currentIcon}
          </div>
        </Popover>
      );
    }
  };





  /// ///////////////////////////////////////////////////////////////////

  const fields: Fields = {
    ...customFields,
  };


  const numCustomFields = Object.fromEntries(
    Object.entries(customFields).filter(([key, value]) => value.type === "number")
  );


  /// ///////////////////////////////////////////////////////////////////
  const funcs: Funcs = {
    // ...BasicFuncs
    string: {
      type: '!struct',
      label: 'String',
      subfields: {
        ...sqlBuilderFunctions.string,
        LENGTH: LENGTH(customFields),
        // STRING_ONLY_FIELDS: STRING_ONLY_FIELDS(customFields),
        CONCAT: merge({}, BasicFuncs.UPPER, {
          tooltip: 'Convert to upper case',
          allowSelfNesting: true,
          label: 'CONCAT',
          mongoFunc: '$toConcat',
          returnType: 'text',
          sqlFunc: 'CONCAT',
          jsonLogic: (formattedArgs) => {
            const finalJsonLogicObject = {
              CONCAT: [],
            };
            finalJsonLogicObject.CONCAT.push(formattedArgs.str);
            finalJsonLogicObject.CONCAT.push(formattedArgs.str2);
            return finalJsonLogicObject;
          },
          args: {
            str: {
              type: 'text',
              valueSources: ['value', 'field', 'func'],
            },
            str2: {
              type: 'text',
              valueSources: ['value', 'field', 'func'],
            },
          },
          sqlFormatFunc: (formattedArgs) => {

            return `CONCAT(${formattedArgs.str}, ${formattedArgs.str2})`;
          },
        }),
        FIND: FIND(customFields),
      },
    },

    date: {
      type: '!struct',
      label: 'Date',
      subfields: {
        NOW: BasicFuncs.NOW,
        // RELATIVE_DATETIME: merge({}, BasicFuncs.RELATIVE_DATETIME, {
        //   args: {
        //     date: {
        //       defaultValue: { func: 'date.NOW', args: [] },
        //     },
        //   },
        // }),
        DATE_BETWEEN,
        DAYS_BETWEEN,
        DATE_ADDITION,
        DATE_SUBTRACTION,
        UNIFIED_DAYS_BETWEEN,
        UNIFIED_WEEKS_BETWEEN,
        UNIFIED_MONTHS_BETWEEN,
        UNIFIED_YEARS_BETWEEN,
        UNIFIED_RANGE_BETWEEN,
      },
    },
    number: {
      type: '!struct',
      label: 'Number',
      subfields: {
        ...sqlBuilderFunctions.number,
        // LINEAR_REGRESSION: BasicFuncs.LINEAR_REGRESSION,
        // ONLY_FIELDS: ONLY_FIELDS(customFields),
        // GREATEST: GREATEST(numCustomFields),
        // LEAST: LEAST(numCustomFields),
        MAX: MAX(numCustomFields),
        MIN: MIN(numCustomFields)
      },
    },



  };

  const { ctx } = InitialConfig;

  const config: Config = {
    ctx,
    conjunctions,
    operators,
    widgets,
    types,
    settings,
    fields,
    funcs,
  };

  return config;
};
